<template>
  <woot-modal :show.sync="show" :on-close="onCancel">
    <div class="h-auto overflow-auto flex flex-col">
      <woot-modal-header
        :header-title="$t('NEW_CONVERSATION.TITLE')"
        :header-content="$t('NEW_CONVERSATION.DESC')"
      />
      <conversation-form
        :contact="contact"
        :on-submit="onSubmit"
        @success="onSuccess"
        @cancel="onCancel"
      />
    </div>
  </woot-modal>
</template>

<script>
import ConversationForm from './ConversationForm';

export default {
  components: {
    ConversationForm,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    contact: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    async 'contact.id'(id) {
      if (id) {
        const inboxData = await this.$store.dispatch('contacts/fetchContactableInbox', id);
        this.$set(this.contact, 'contactableInboxes', inboxData.contactableInboxes);
      }
    },
    async show(isVisible) {
      if (isVisible && this.contact?.id) {
        const inboxData = await this.$store.dispatch('contacts/fetchContactableInbox', this.contact.id);
        this.$set(this.contact, 'contactableInboxes', inboxData.contactableInboxes);
      }
    },
  },
  async mounted() {
    const id = this.contact?.id;
    if (id) {
      const inboxData = await this.$store.dispatch('contacts/fetchContactableInbox', id);
      this.$set(this.contact, 'contactableInboxes', inboxData.contactableInboxes);
    }
  },  

  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    onSuccess() {
      this.$emit('cancel');
    },
    async onSubmit(contactItem) {
      const data = await this.$store.dispatch(
        'createConversationFromContact',
        contactItem
      );
      return data;
    },
  },
};
</script>
